module.exports = __webpack_public_path__ + "img/yzh4.08bc945e.jpg";